import type { NbxHubOptions } from "./types";

const DEFAULT_BASE_URL =
  import.meta.env.VITE_NBX_HUB_BASE_URL || "http://localhost:4200";

/**
 * Builds the iframe URL with query parameters
 */
export function buildIframeUrl(options: NbxHubOptions): string {
  const baseUrl = options.baseUrl || DEFAULT_BASE_URL;

  const params = new URLSearchParams({
    embed: "true",
    companyId: options.companyId,
    feature: options.feature,
  });

  if (options.token) {
    params.set("token", options.token);
  }

  if (options.params) {
    Object.entries(options.params).forEach(([key, value]) => {
      params.set(key, value);
    });
  }

  // Route to the feature
  const featureRoute = getFeatureRoute(options.feature);

  return `${baseUrl}${featureRoute}?${params.toString()}`;
}

/**
 * Maps feature names to routes
 */
function getFeatureRoute(feature: string): string {
  const routes: Record<string, string> = {
    midt: "/midt/purchase",
    documents: "/documents",
    reports: "/reports",
    profile: "/profile",
  };

  return routes[feature] || `/${feature}`;
}

/**
 * Sets up iframe load event handling
 */
export function onIframeLoad(
  iframe: HTMLIFrameElement,
  onLoad: () => void,
  onError: (error: Error) => void,
): void {
  let loaded = false;

  const handleLoad = () => {
    if (loaded) return;
    loaded = true;
    onLoad();
  };

  const handleError = () => {
    if (loaded) return;
    loaded = true;
    onError(new Error("Failed to load iframe content"));
  };

  iframe.addEventListener("load", handleLoad);
  iframe.addEventListener("error", handleError);

  // Timeout fallback
  setTimeout(() => {
    if (!loaded) {
      onError(new Error("Iframe load timeout"));
    }
  }, 30000);
}

/**
 * Gets the iframe element from the modal
 */
export function getIframe(): HTMLIFrameElement | null {
  return document.querySelector(
    "#nbx-hub-modal iframe",
  ) as HTMLIFrameElement | null;
}
